"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _Popover = _interopRequireDefault(require("../Popover"));

var _SecondaryButton = _interopRequireDefault(require("./SecondaryButton"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _Icon = _interopRequireDefault(require("../Icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MultiSecondaryButton = function MultiSecondaryButton(_ref) {
  var style = _ref.style,
      className = _ref.className,
      actions = _ref.actions,
      _ref$visibleButtonCou = _ref.visibleButtonCount,
      visibleButtonCount = _ref$visibleButtonCou === void 0 ? 1 : _ref$visibleButtonCou,
      dropDownPosition = _ref.dropDownPosition,
      _ref$dropDownContentW = _ref.dropDownContentWidth,
      dropDownContentWidth = _ref$dropDownContentW === void 0 ? 190 : _ref$dropDownContentW;
  var styles = useStylesheet();

  var _useTheme = (0, _providers.useTheme)(),
      borderPrimary = _useTheme.borderPrimary,
      textDark = _useTheme.textDark,
      primary = _useTheme.primary,
      textWhite = _useTheme.textWhite;

  if (actions.length == 0) {
    return null;
  }

  var visibleActions = actions.slice(0, visibleButtonCount);
  var listActions = actions.slice(visibleButtonCount);

  var renderList = function renderList() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _styling.css)(styles.list)
    }, listActions.map(function (_ref2, idx) {
      var style = _ref2.style,
          action = (0, _objectWithoutProperties2["default"])(_ref2, ["style"]);
      return /*#__PURE__*/_react["default"].createElement(_SecondaryButton["default"], (0, _extends2["default"])({}, action, {
        key: action.text,
        padding: "9px 15px",
        style: _objectSpread(_objectSpread({}, style), {}, {
          minWidth: dropDownContentWidth ? dropDownContentWidth - 30 : 160,
          fontSize: 16,
          borderBottom: idx < listActions.length - 1 && "1px solid ".concat(borderPrimary),
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          color: textDark,
          ":hover": {
            color: textWhite,
            backgroundColor: primary
          }
        }),
        border: "none",
        borderRadius: 0
      }));
    }));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(className, style, styles.root)
  }, visibleActions.map(function (action) {
    return /*#__PURE__*/_react["default"].createElement(_SecondaryButton["default"], (0, _extends2["default"])({
      key: action.text
    }, action, {
      className: (0, _styling.css)(styles.inlineButton),
      padding: "7px 25px"
    }));
  }), listActions.length > 0 && /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    popoverContent: function popoverContent() {
      return renderList();
    },
    position: dropDownPosition || "bottom center",
    contentWidth: dropDownContentWidth
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.ellipseButton)
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "ellipseV",
    style: {
      height: 18
    }
  }))));
};

var useStylesheet = function useStylesheet() {
  var _useTheme2 = (0, _providers.useTheme)(),
      surfaceLightest = _useTheme2.surfaceLightest,
      primaryLight = _useTheme2.primaryLight;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      inlineButton: {
        marginRight: 5
      },
      ellipseButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: "all 0.2s linear",
        opacity: 0.8,
        width: 30,
        height: 30,
        backgroundColor: surfaceLightest,
        ":hover": {
          opacity: 1,
          backgroundColor: primaryLight
        },
        borderRadius: "50%"
      },
      list: {
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        margin: "10px 0px"
      }
    });
  }, [primaryLight, surfaceLightest]);
};

MultiSecondaryButton.propDoc = {
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates if the button is disabled. " + "Set this to true while making an API call."
  },
  actions: {
    required: true,
    type: "ReadonlyArray<SecondaryButtonProps>",
    description: "List of available actions. The first one will appear on " + "the button. Can see " + "[`SecondaryButtonProps here`](/@lego/component/button/SecondaryButton)"
  },
  padding: {
    required: false,
    defaultValue: "7px <based on screen size>px",
    type: "string",
    description: "Internal padding of the button"
  },
  popoverContent: {
    required: false,
    defaultValue: "null",
    type: "(string | null) | ((() => ReactNode))",
    description: "Set if the button displays a popover when hovered. Value is the " + "popover's content: either string or a custom render function "
  },
  popoverPosition: {
    required: false,
    defaultValue: "top center",
    type: "(string | null)",
    description: "Position of the button's popover -- if it has one"
  },
  visibleButtonCount: {
    required: false,
    defaultValue: "1",
    type: "number",
    description: "Number of buttons that should be visible at all times. The rest will be " + "folded into the dropdown."
  }
};
MultiSecondaryButton.demoProps = {
  actions: [{
    text: "Action 1",
    onClick: function onClick() {},
    href: "#"
  }, {
    text: "Action 2",
    onClick: function onClick() {},
    href: "#"
  }, {
    text: "Action 3",
    onClick: function onClick() {},
    href: "#"
  }],
  visibleButtonCount: 2
};
var _default = MultiSecondaryButton;
exports["default"] = _default;